import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "100px", // Increased height
        padding: "15px 20px", // Padding for spacing
        backgroundColor: "lightgray", // Light gray background
        color: "#fff", // White text
        fontSize: "1rem",
      }}
    >
      {/* Left: Copyright */}
      <div style={{ fontWeight: "1000" }}>
        © {new Date().getFullYear()} All Rights Reserved.
      </div>

      {/* Right: Powered by */}
      <div style={{ fontWeight: "1000" }}>
        Powered by <span style={{ fontWeight: "bold" }}>Real Estate</span>
      </div>
    </footer>
  );
};

export default Footer;
